import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { ConfiguracionService } from 'src/app/despacho/configuracion.service';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';
import { CBU } from 'src/app/shared/models/cliente/CBU';
import { Cliente } from 'src/app/shared/models/cliente/Cliente';
import { ClienteService } from '../cliente.service';
import { MessageService } from 'src/app/shell/message.service';

@Component({
  selector: 'app-modal-cbu',
  templateUrl: './modal-cbu.component.html',
  styleUrls: ['./modal-cbu.component.scss']
})
export class ModalCBUComponent implements OnInit {

  @Input() clienteCBU: Cliente;
  @Output() clienteAMostrar: Cliente;
  @Output() todosCBU: EventEmitter<CBU[]> = new EventEmitter();

  guardando: boolean = false;
  editField: string;
  agregarCBUNuevo: boolean = false;
  nuevosCBU: CBU[]=[];
  tablaCBU = new UntypedFormGroup({
    enUsoCheckFormControl: new UntypedFormControl('', Validators.required),
  });
  agregarCBUForm = new UntypedFormGroup({
    nuevoTipoBancoInterlocutorFormControl: new UntypedFormControl(''),
    nuevoCBUFormControl: new UntypedFormControl(''),
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbModal,
    private configuracionService: ConfiguracionService,
    private clienteService: ClienteService,
    private authService:AuthService,
    private changeDetector: ChangeDetectorRef,
    private messageService: MessageService) {
  }

  ngOnInit() {
    if (this.clienteCBU.cbUs != null)
    {
      this.clienteCBU.cbUs.sort((a , b) => a.tipoBancoInterlocutor - b.tipoBancoInterlocutor);
    }
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }


  esSupervisor()
  {
   return this.authService.hasRole(TipoUsuario.SUPERVISOR)
  }

  usuarioHabilitado()
  {
   return this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.ADMCLIENTES);
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0 ) ? null : (event.charCode >= 48 && event.charCode <= 57);
  }

  /**
   * Determina si una cadena se encuentra dentro de otra
   * @param searchValue Valor a buscar
   * @param searchIn Valores sobre los que buscar searchValue
   */
  containsString(searchValue: string, ...searchIn: string[]): boolean {
    const concat = searchIn.toString();
    return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  }

  changeValue(id: number, event: any) {
    this.editField = event.target.textContent;
  }

  actualizar(id: number, event: any) {
      const editField = event.target.textContent.trim();    
      this.clienteCBU.cbUs[id].cbu = editField;
  }

  guardarCBU() {
    Array.prototype.push.apply(this.clienteCBU.cbUs, this.nuevosCBU);
    this.todosCBU.emit(this.clienteCBU.cbUs);
    this.activeModal.dismissAll();
  }

  usuarioModificaCampos(): boolean {
    return this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.ADMCLIENTES);
  }

  agregarCBU(){
    this.agregarCBUNuevo = true;
  }

  asignarCBU(){
    if (!this.agregarCBUForm.valid) {
      this.messageService.showErrorMessage('Por favor revise lo datos necesarios para el CBU.')
    } else {
        let c = new CBU();
        c.tipoBancoInterlocutor = parseInt( this.nuevoTipoBancoInterlocutor.value);
        c.cbu = this.nuevoCBU.value;
        c.enUso = false;
        if (c.enUso) this.hayPorDefecto(c);
        this.nuevosCBU.push(c);
        this.nuevosCBU.sort((a , b) => a.tipoBancoInterlocutor - b.tipoBancoInterlocutor);
        this.nuevoCBU.setValue('');
        this.nuevoTipoBancoInterlocutor.setValue('');  
        this.enUsoCheck.setValue(false);
    }
  }

  desasignarCBU(c: CBU) {
    const index: number = this.nuevosCBU.indexOf(c);
    if (index !== -1) {
      this.nuevosCBU.splice(index, 1);
    }
  }

  hayPorDefecto(c: CBU) {
    this.clienteCBU.cbUs.forEach((value, index) => {
      if (this.clienteCBU.cbUs[index] != c) {
        this.clienteCBU.cbUs[index].enUso = false;
      }

    })
  }

  checkearDefecto(c: CBU) {
    if (c.enUso == true) {
      c.enUso = false;
    } else {
      c.enUso = true;
      this.hayPorDefecto(c);
    }
  }

  //Getters
  get enUsoCheck() {
    return this.tablaCBU.controls.enUsoCheckFormControl;
  }

  get nuevoCBU() {
    return this.agregarCBUForm.controls.nuevoCBUFormControl;
  }

  get nuevoTipoBancoInterlocutor() {
    return this.agregarCBUForm.controls.nuevoTipoBancoInterlocutorFormControl;
  }

  

}
